import { Descriptions, Space } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import { convertObjectKeysToString } from '@nxsys/utils/activityLog';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppDescription from '@nxsys/components/AppDescription';
import { ChangeItem } from '@nxsys/types/models/banner';

const ModalLogDetails = ({
  visible = false,
  data = {},
  toggle = () => {},
  type = 'employee',
}: {
  visible: boolean;
  data: any;
  toggle: () => void;
  type: 'employee' | 'agency' | 'company';
}) => {
  if (!data || isEmpty(data)) return null;
  const {
    subcontractorRef,
    logDetails,
    updatedAt,
    updatedBy,
    isSuperAdmin,
    agencyRef,
    companyRef,
    changes = [],
    error,
  } = data || {};

  const renderLogChanges = () => {
    if (!error && !changes?.length) return null;

    const errorItem = error ? (
      <Descriptions.Item key="error" label="Error">
        <div className="text-red-500">{error.toString()}</div>
      </Descriptions.Item>
    ) : null;

    return [
      errorItem,
      ...(changes as ChangeItem[]).map((change, index) => (
        <Descriptions.Item
          key={`change-${index}`}
          label={change.label || convertObjectKeysToString(change.key)}
        >
          <div style={{ lineHeight: '1.6' }}>
            <div>Previous: {change.oldValue ?? '_'}</div>
            <div>New: {change.newValue ?? '_'}</div>
          </div>
        </Descriptions.Item>
      )),
    ];
  };

  return (
    <AppModalContainer
      title="Activity Log Detail"
      isOpen={visible}
      toggle={toggle}
      actions={[
        {
          name: 'Close',
          variant: 'outlined',
          buttonType: 'primary',
          onClick: toggle,
        },
      ]}
    >
      <AppDescription
        column={1}
        labelStyle={{ width: 200 }}
        bordered={false}
        colon={false}
        size="middle"
      >
        <Descriptions.Item
          label={
            type === 'employee'
              ? 'Employee'
              : type === 'company'
                ? 'Company'
                : 'Agency'
          }
        >
          {type === 'employee'
            ? `${subcontractorRef?.forename || ''} ${subcontractorRef?.surname || ''}`.trim() ||
              '-'
            : type === 'company'
              ? companyRef?.companyName || '-'
              : agencyRef?.name || '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Log Details">
          {logDetails?.toString() || '-'}
        </Descriptions.Item>

        {renderLogChanges()}

        <Descriptions.Item label="Last Updated At">
          {updatedAt ? (
            <Space>
              <div>{moment.utc(updatedAt).local().format('DD/MM/YYYY')}</div>
              <div className="text-neutral-400 font-[500]">
                {moment.utc(updatedAt).local().format('hh:mma')}
              </div>
            </Space>
          ) : (
            '-'
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Updated By">
          {isSuperAdmin
            ? 'Super Admin'
            : `${updatedBy?.forename || ''} ${updatedBy?.surname || ''}`.trim() ||
              '-'}
        </Descriptions.Item>
      </AppDescription>
    </AppModalContainer>
  );
};

export default React.memo(ModalLogDetails);
